<div>
    <div>
        <h6>Select date range</h6>
    </div><br>
    <div>
        <div class="select">
            <div class="select">
                <div>Start Date</div>
                <div>
                    <input nbInput placeholder="pick a day range" [nbDatepicker]="startPicker" [(ngModel)]="startDate">
                </div>
            </div>
            <nb-datepicker #startPicker [max]="endDate"></nb-datepicker><br><br>
        </div><br>
        <div class="select">
            <div class="select">
                <div>End Date</div> 
                <div>
                    <input nbInput placeholder="pick a day range" [nbDatepicker]="endPicker" [(ngModel)]="endDate">
                </div>
            </div>
            <nb-datepicker #endPicker [min]="startDate" [max]="maxEndDate"></nb-datepicker><br><br>
        </div><br>
        <button nbButton status="primary" mat-dialog-close (click)="this.dashService.getCustomRangeSummary(startDate,endDate)">Go</button>
    </div>
</div>